export default __webpack_public_path__ + "static/media/arrowdone.2e115eef.svg";